import { Button } from "@components/ui/button";
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@components/ui/empty";
import { MessageCircleIcon } from "lucide-react";
import { Link } from "react-router-dom";
import { ROUTES } from "@/routes_new";
import { Trans } from "@lingui/react/macro";

export function EmptySearches({ orgUuid }: { orgUuid: string }) {
  return (
    <Empty className="py-4 md:py-6">
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <MessageCircleIcon />
        </EmptyMedia>
        <EmptyTitle>
          <Trans>Inga bevakningar skapade</Trans>
        </EmptyTitle>
        <EmptyDescription>
          <Trans>Du har inte skapat några bevakningar än.</Trans>
        </EmptyDescription>
      </EmptyHeader>
      <EmptyContent>
        <Button asChild>
          <Link to={ROUTES.MENTION_NEW_ORGID.replace(":orgUuid", orgUuid)}>
            <Trans>Skapa bevakning</Trans>
          </Link>
        </Button>
      </EmptyContent>
    </Empty>
  );
}
